import { AfterViewChecked, Component, ElementRef, Input, Renderer2, ViewChild } from '@angular/core';
import { TableSection } from 'src/app/model/shared/table-section';

import { ModalComponent } from '../modal/modal.component';
import { documentToHtmlString } from '.';

@Component({
  selector: 'app-api-reference-table-section',
  templateUrl: './api-reference-table-section.component.html',
  styleUrls: ['./api-reference-table-section.component.scss']
})
export class ApiReferenceTableSectionComponent implements AfterViewChecked {
  @Input() tableSections: TableSection[] = [];
  @Input() isDefault: boolean = true;
  @Input() apiReferenceErrorResponsePage: boolean = false;
  @Input() apiReferenceXMLSamplePage: boolean = false;
  @Input() languageSupportedPage: boolean = false;
  @Input() testingYourBuildPage: boolean = false;
  @Input() testingYourBuildSecureCardAuthenticationPage: boolean = false;
  @ViewChild('modal') modal!: ModalComponent;

  eventListenersAdded: boolean = false;

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  ngAfterViewChecked(): void {
    let elements = (<HTMLElement>this.elementRef.nativeElement).querySelectorAll('.xmlModal');
    if (elements.length > 0 && !this.eventListenersAdded) {
      this.eventListenersAdded = true;
      elements.forEach((element) =>
        this.renderer.listen(element, 'click', () => {
          this.modal.open(element.getAttribute('title') || '');
        })
      );
    }
  }

  returnHtmlFromRichText(richText: any): string {
    if (richText === undefined || richText === null || richText.nodeType !== 'document') {
      return '<p>Error</p>';
    }

    return documentToHtmlString(richText);
  }
}
